'use client'

import { useState } from 'react'

import { Button, ButtonProps } from '@/components/ui/button'
import { VideoDialog } from '@/components/VideoDialog'

export function PreviewVideoButton({
  label,
  videoTitle,
  videoEmbedUrl,
  ...buttonProps
}: {
  label: string
  videoTitle: string
  videoEmbedUrl: string
} & Omit<ButtonProps, 'onClick' | 'children'>) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <>
      <Button {...buttonProps} onClick={() => setIsDialogOpen(true)}>
        {label}
      </Button>
      <VideoDialog
        videoTitle={videoTitle}
        videoEmbedUrl={videoEmbedUrl}
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
      />
    </>
  )
}
